﻿import moment from 'moment';
const humanizeDuration = require("humanize-duration");
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

import {
    max_times_exception_count_warning,
    max_times_exception_count_severe,
    max_response_time_for_warning,
    max_response_time_for_severe,
    max_response_time_times_warning,
    max_response_time_times_severe,
    notifications_session_storage_key
} from '@Util/GlobalValues';

import {
    Time_Log_Entry,
    Client_Website_Type,
    Current_Project
} from '@Util/Types';

export const dev_mode: boolean = process.env.NODE_ENV === "development" ? true : false;
dayjs.extend(duration);

export function write_console(object: any, txt: string): void {
    if (dev_mode) {
        console.group(`%c ${txt}`, `color: green; font-weight: bold; font-size: 15px;`);
        console.log(object);
        console.groupEnd();
    }
}

export function write_console_error(error: any, txt: string): void {
    if (dev_mode) {
        console.group(`%c ${txt}`, `color: red; font-weight: bold; font-size: 15px;`);
        console.log(error);
        console.groupEnd();
    }
}

/*export function str_isEmpty(strEntry: string): boolean {
    if (!strEntry)
        return true;

    if (strEntry.trim().length === 0)
        return true;

    return false;
}*/

export function str_isEmpty(strEntry: any): boolean {
    return typeof strEntry !== 'string' || strEntry.trim().length === 0;
}

/*export function generate_unique_id(): string {
    const timestamp: number = Date.now();
    const random: number = Math.floor(Math.random() * 10000);
    const uniqueID: string = `${timestamp}${random}`;

    return uniqueID;
}*/

export function generate_unique_id(): string {
    const timestamp: number = Date.now();
    const random: number = Math.floor(Math.random() * 1e6); // Increased randomness range
    const uniqueID: string = `${timestamp}-${random.toString().padStart(6, '0')}`; // Padded to ensure length consistency

    return uniqueID;
}

/*export function validate_email(email_str: string): boolean {
    const regex_pattern = /^(?=.{1,254}$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!-)[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(?<!-)$/;

    return regex_pattern.test(email_str);
}*/

export function validate_email(email_str: string): boolean {
    // Early return for obvious invalid cases
    if (!email_str || typeof email_str !== 'string') {
        return false;
    }

    // Optimized regex pattern for email validation
    const regex_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return regex_pattern.test(email_str);
}

export function insertCharacterIntoString(main_string: string, ins_string: string, pos: number): string {
    if (typeof (pos) == "undefined") {
        pos = 0;
    }
    if (typeof (ins_string) == "undefined") {
        ins_string = '';
    }
    return main_string.slice(0, pos) + ins_string + main_string.slice(pos);
}

/*export function remove_unsupported_characters(str: string): string {
    try {
        if (str_isEmpty(str)) {
            throw new Error("Filnamnet är tomt");
        }

        let tempString: string = str;
        tempString.replace(/[öÖ]/g, 'o');
        tempString.replace(/[äÄ]/g, 'a');
        tempString.replace(/[åÅ]/g, 'a');
        tempString.replace(/[^a-zA-Z0-9]/g, '_');

        return tempString;
    } catch (err) {
        console.error(err.message);
    }
}*/

export function remove_unsupported_characters(str: string): string {
    if (str_isEmpty(str)) {
        console.error("Filnamnet är tomt");
        return '';
    }

    return str
        .replace(/[öÖ]/g, 'o')
        .replace(/[äÄ]/g, 'a')
        .replace(/[åÅ]/g, 'a')
        .replace(/[^a-zA-Z0-9]/g, '_');
}

declare global {
    interface Array<T> {
        isEmpty(): boolean;
    }
}

Array.prototype.isEmpty = function () {
    if (this.length === 0) return true;
    else return false;
};

// CALCULATES THE TOTAL WORKING HOURS
//export function get_total_working_hours(arr: Time_Log_Entry[], exportAs: string): string {
//    const totalHours: number = arr.reduce((sum, log) => {
//        const start: moment.Moment = moment(log.startDate);
//        const stop: moment.Moment = moment(log.endDate);
//        const diff = stop.diff(start);
//        return sum + diff;
//    }, 0);
//
//    if (exportAs === "asHours") {
//        return moment.duration(totalHours).asHours().toFixed(1).toString();
//    } else {
//        return humanizeDuration(moment.duration(totalHours, 'milliseconds'), { language: "sv", units: ["h", "m"], maxDecimalPoints: 0 });
//    }
//}

/*export function get_total_working_hours(arr: Time_Log_Entry[], current_project: Current_Project): string {
    const totalMsFromLogs: number = arr.reduce((sum, log) => {
        const start = dayjs(log.startDate);
        const stop = dayjs(log.endDate);
        const diff = stop.diff(start);
        return sum + diff;
    }, 0);

    let elapsedMs = 0;
    if (current_project !== null && current_project.id !== 0) {
        const now = dayjs();
        const startOfToday = dayjs().startOf('day');
        const projectStart = dayjs(current_project.startDate);
        const startTime = projectStart.isAfter(startOfToday) ? projectStart : startOfToday;
        elapsedMs = now.diff(startTime);
    }

    const totalMs: number = totalMsFromLogs + elapsedMs;
    const dur = dayjs.duration(totalMs);
    const hours = Math.floor(dur.asHours());
    const minutes = dur.minutes();
    return `${hours}h, ${minutes}m`;
}*/

/*export function get_total_working_hours(
    arr: Time_Log_Entry[],
    current_project: Current_Project
): string {
    // Total from logs
    const totalMsFromLogs = arr.reduce((sum, log) => {
        const start = dayjs(log.startDate);
        const stop = dayjs(log.endDate);
        const diff = stop.diff(start);
        return sum + diff;
    }, 0);

    let elapsedMs = 0;

    if (current_project && current_project.id !== 0 && current_project.startDate) {
        const now = dayjs();
        const projectStart = dayjs(current_project.startDate);

        const startTime = projectStart.isAfter(now) ? now : projectStart;

        elapsedMs = now.diff(startTime);

        if (elapsedMs < 0) elapsedMs = 0;
    }

    const totalMs = totalMsFromLogs + elapsedMs;

    const safeTotalMs = totalMs < 0 ? 0 : totalMs;

    const dur = dayjs.duration(safeTotalMs);
    const hours = Math.floor(dur.asHours());
    const minutes = dur.minutes();

    return `${hours}h, ${minutes}m`;
}*/

export function get_total_working_hours(
    arr: Time_Log_Entry[],
    current_project: Current_Project
): string {
    let totalMsFromLogs = 0;

    for (const log of arr) {
        const start = dayjs(log.startDate);
        const stop = dayjs(log.endDate);

        if (!start.isValid() || !stop.isValid()) continue; // skip invalid logs

        const diff = stop.diff(start);
        if (diff > 0) totalMsFromLogs += diff; // skip negative durations
    }

    let elapsedMs = 0;

    if (current_project?.id && current_project.startDate) {
        const now = dayjs();
        const projectStart = dayjs(current_project.startDate);

        // Ensure we don’t get negative elapsed time
        const startTime = projectStart.isAfter(now) ? now : projectStart;
        elapsedMs = Math.max(now.diff(startTime), 0);
    }

    const totalMs = Math.max(totalMsFromLogs + elapsedMs, 0);

    const dur = dayjs.duration(totalMs);
    const hours = Math.floor(dur.asHours());
    const minutes = dur.minutes();

    return `${hours}h, ${minutes}m`;
}

export type Reported_Working_Hours_Export = "asDetailed" | "asHours";

export interface Reported_Working_Hours_Summary {
    detailed?: string;
    overview?: string;
}

/** Reported timelog totals only (no active project). Used on the start page header. */
export function get_reported_working_hours(
    arr: Time_Log_Entry[] | undefined | null,
    exportAs: Reported_Working_Hours_Export
): string | undefined {
    if (!arr?.length) {
        return undefined;
    }

    let totalMs = 0;

    for (const log of arr) {
        const start = moment(log.startDate);
        const stop = moment(log.endDate);
        totalMs += stop.diff(start);
    }

    const duration = moment.duration(totalMs, "milliseconds");

    if (exportAs === "asHours") {
        return duration.asHours().toFixed(1).toString();
    }

    return humanizeDuration(duration, { language: "sv", units: ["h", "m", "s"], maxDecimalPoints: 0 });
}

export function get_reported_working_hours_summary(
    arr: Time_Log_Entry[] | undefined | null
): Reported_Working_Hours_Summary {
    return {
        detailed: get_reported_working_hours(arr, "asDetailed"),
        overview: get_reported_working_hours(arr, "asHours"),
    };
}

// SHA256 HASH FUNCTION
const stringToArrayBuffer = (str) => {
    const encoder = new TextEncoder();
    return encoder.encode(str);
};

// Convert an ArrayBuffer to a hex string
const arrayBufferToHexString = (buffer) => {
    const byteArray = new Uint8Array(buffer);
    const hexString = byteArray.reduce((acc, byte) => {
        return acc + ('0' + byte.toString(16)).slice(-2);
    }, '');
    return hexString;
};

// Create SHA256 hash
export const createSHA256Hash = async (message) => {
    const arrayBuffer = stringToArrayBuffer(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
    return arrayBufferToHexString(hashBuffer);
};

export const monthOptions: { value: string, label: string }[] = [
    {
        value: "1",
        label: "Januari"
    },
    {
        value: "2",
        label: "Februari"
    },
    {
        value: "3",
        label: "Mars"
    },
    {
        value: "4",
        label: "April"
    },
    {
        value: "5",
        label: "Maj"
    },
    {
        value: "6",
        label: "Juni"
    },
    {
        value: "7",
        label: "Juli"
    },
    {
        value: "8",
        label: "Augusti"
    },
    {
        value: "9",
        label: "September"
    },
    {
        value: "10",
        label: "Oktober"
    },
    {
        value: "11",
        label: "November"
    },
    {
        value: "12",
        label: "December"
    }
]

export class weekUtils {
    private static swedishMonths = [
        "Jan", "Feb", "Mar", "Apr", "Maj", "Jun",
        "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"
    ];

    // Get the number of ISO weeks in a given year
    static getIsoWeeksInYear(year: number): number {
        return moment(`${year}-12-28`).isoWeeks(); // 28 Dec is always in the last ISO week
    }

    // Generate week options for a given year
    static generateWeekOptions(year?: number): { value: string, label: string }[] {
        const currentYear = year || moment().year();
        const totalWeeks = this.getIsoWeeksInYear(currentYear);

        return Array.from({ length: totalWeeks }, (_, i) => {
            const weekNumber = i + 1;
            const startOfWeek = moment().year(currentYear).isoWeek(weekNumber).startOf('isoWeek');
            const endOfWeek = moment(startOfWeek).endOf('isoWeek');

            const startLabel = `${startOfWeek.date()} ${this.swedishMonths[startOfWeek.month()]}`;
            const endLabel = `${endOfWeek.date()} ${this.swedishMonths[endOfWeek.month()]}`;

            return {
                value: weekNumber.toString(),
                label: `${weekNumber} - (${startLabel} / ${endLabel})`
            };
        });
    }

    static getWeekRange(weekNumber: number, year?: number): { start: moment.Moment, end: moment.Moment } {
        // Use current year if not provided
        const currentYear = year || moment().year();

        // Validate week number
        const totalWeeks = this.getIsoWeeksInYear(currentYear);
        if (weekNumber < 1 || weekNumber > totalWeeks) {
            throw new Error(`Invalid week number ${weekNumber} for year ${currentYear}`);
        }

        // Start and end of the ISO week
        const startOfWeek = moment().year(currentYear).isoWeek(weekNumber).startOf('isoWeek');
        const endOfWeek = moment(startOfWeek).endOf('isoWeek');

        return { start: startOfWeek, end: endOfWeek };
    }
}

export function site_should_show_last_exception_warning(website: Client_Website_Type): boolean {
    if (typeof website.averageExceptionCount === 'number' && website.lastExceptionCount >= 0) {
        const is_zero_average = Math.round(website.averageExceptionCount) === 0;
        const is_severe_exception = website.lastExceptionCount > max_times_exception_count_severe;
        const is_average_exception = website.lastExceptionCount >= (website.averageExceptionCount * max_times_exception_count_severe);

        // IF THE AVERAGE EXCEPTION COUNT IS 0 AND THE LAST EXCEPTION COUNT IS GREATER THAN THE SEVERE LIMIT
        if ((is_zero_average && is_severe_exception) || (!is_zero_average && is_average_exception)) {
            return true;
        }
    }

    return false;
}

export function site_should_show_last_response_time_warning(website: Client_Website_Type): boolean {
    if (website.lastResponseTime && website.lastResponseTime >= max_response_time_for_severe) {
        return true;
    }

    return false;
}